'use strict';

import React, {Component} from 'react';
import PropTypes from "prop-types";
import {observer} from "mobx-react";

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';

import SimpleState from "@uw-it-sis/lib-react/lib/SimpleState";
import {capitalize} from "@uw-it-sis/lib-react/lib/Utils";

import addressStore from "./AddressStore";
import RegistrationFailure from "../registration/RegistrationFailure";

const AddressFormatter = (props) => {
    let address, phone;

    if (props.line_1.trim().length === 0) {
        address = <p>Address information not provided.</p>
    } else {
        let line1 = props.line_1.trim().length ? <>{props.line_1}<br/></> : null;
        let line2 = props.line_2.trim().length ? <>{props.line_2}<br/></> : null;
        let city = props.city.trim().length ? <>{props.city}</> : null;
        let state = props.state.trim().length ? <>&nbsp;&nbsp;{props.state}</> : null;
        let zip = props.zip_5.trim().length ? (
            props.zip_5.trim().length && props.zip_filler_b.trim().length ?
                <>&nbsp;&nbsp;{props.zip_5}-{props.zip_filler_b}</> : <>&nbsp;&nbsp;{props.zip_5}</>
        ) : null;
        let postal = props.postal_cd.trim().length ? <>&nbsp;&nbsp;{props.postal_cd}</> : null;
        let country = props.country.trim().length ? <>{props.country}</> : null;
        let line3;

        if (country) {
            line3 =
                <>
                    {city}
                    {state}
                    {postal}
                    <br />
                    {country}
                </>
        } else {
            line3 =
                <>
                    {city}
                    {state}
                    {zip}
                </>
        }

        address =
            <p translate="no" className="mb-0">
                {line1}
                {line2}
                {line3}
            </p>
    }

    if (props.phone_area.trim().length > 0) {
        phone = <p>{props.phone_area}-{props.phone_prefix}-{props.phone_suffix}</p>
    }

    return (
        <>
            {address}
            {phone}
        </>
    )
}

class Address extends Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.store = addressStore;
    }

    componentDidMount() {
        this.store.mount();
    }

    buildDoneComponent = () => {
        let addressObjs = {
            local_address: "Local Address",
            permanent_address: "Permanent Address",
            parent_address: "Parent/Family Member Contact"
        }

        let addresses = Object.entries(addressObjs).map(([key, value], index) => {
            return (
                <div key={index}>
                    <h4 className="h4">{value}:</h4>
                    <div className="ps-4">
                        {key === "parent_address" && this.store.formData.hasOwnProperty("parent_name")? <p className="mb-0">{this.store.formData.parent_name}</p>: null}
                        <AddressFormatter {...this.store.formData[key]} />
                    </div>
                </div>
            )
        });

        let emergencyContact;
        if (Object.values(this.store.formData.emergency_contact).some(v => v.trim().length > 0)) {
            emergencyContact = Object.entries(this.store.formData.emergency_contact).map(([key, value], index) => {
                if (value.trim().length > 0) {
                    return <div key={index}>{capitalize(key)}: {value}</div>
                } else {
                    return <div key={index}>Contact {key} not provided.</div>
                }
            });
        } else {
            emergencyContact = <>Emergency contact information not provided.</>;
        }

        return (
            <>
                <p>
                    Below is your address information on file. Please carefully review this information.
                    If anything is not correct, go to
                    the <a href="https://sdb.admin.uw.edu/sisStudents/uwnetid/address.aspx" target="_blank" onClick={() => handleGoto("Address and Consent")}>Address and Consent page</a> (opens
                    in a new tab) to update it.
                </p>
                <Card bg="transparent" className="border my-3">
                    <Card.Body>
                        <Row>
                            <Col className="space-y-3">
                                {addresses}
                            </Col>
                            <Col>
                                <div>
                                    <h4 className="h4">
                                        Address usage for mailings:
                                    </h4>
                                    <ul>
                                        <li>Registration Confirmation to my {this.store.formData.sched_to === "L" ? "LOCAL":"PERMANENT"} address.</li>
                                        <li>Tuition Statement to my {this.store.formData.bill_to === "L" ? "LOCAL":"PERMANENT"} address.</li>
                                        <li>Financial Aid mailings to my {this.store.formData.finaid_to === "L" ? "LOCAL":"PERMANENT"} address.</li>
                                    </ul>
                                </div>
                                <div>
                                    <h4 className="h4">Directory Release:</h4>
                                    <ul>
                                        <li>{this.store.formData.directory_release ? <><strong>YES</strong>, the</> : "The"} University of
                                            Washington {this.store.formData.directory_release ? "may":<strong>MAY NOT</strong>} release my
                                            name, address and other directory information to anyone and include it in the Student Directory.</li>
                                    </ul>
                                </div>
                                <div>
                                    <h4 className="h4">Emergency Contact:</h4>
                                    <div className="ps-4">
                                        {emergencyContact}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
                <p>If this address information is all correct, you can continue to the Insurance/Optional Charges page. This will open the page in the Registration system in a new tab.</p>
                <p>When you’re done, close that tab to return to this page.</p>
            </>
        )
    }

    buildErrorComponent = () => {
        return <RegistrationFailure isWithinModal />
    }

    render() {
        return (
            <SimpleState state={this.store.state}
                         doneComponentBuilder={() => this.buildDoneComponent()}
                         pendingComponentBuilder="dots"
                         errorComponentBuilder={() => this.buildErrorComponent()}
                         name="Address" />
        );
    }
}

export default observer(Address);